import { Container, Typography } from '@mui/material'
import React from 'react'
import { useLocation } from 'react-router-dom'

function Faq() {
    const location = useLocation()
    return (
        <Container maxWidth={'lg'} sx={{ pt: 4 ,minHeight:'70vh'}}>
            <Typography variant='h4' component={'h4'} mb={3} textTransform={'none'}>
                FAQ
            </Typography>
            <Typography variant='p' component={'p'}>
                What is Lorem Ipsum?
                Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
            </Typography>
        </Container>
    )
}

export default Faq